import React from 'react';
import Layout from '../components/layout';
import { Link } from 'gatsby';
import SEO from '@accrosoft-ltd/accropress-websites-components/dist/esm/seo';
import '../components/wig-bundle.scss';
import { returnResizedImageURL } from '@accrosoft-ltd/accropress-websites-components/dist/esm/imgUtils';
import TableOfContents from '@accrosoft-ltd/accropress-websites-components/dist/esm/tableOfContents';
import loadable from '@loadable/component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var WigLoader = loadable(function () {
  return import('@accrosoft-ltd/accropress-websites-components/dist/esm/wigLoader');
});

var gatsbyConfig = require('../../theme-config.js');

var gatsbyConfigSiteMetaData = gatsbyConfig.siteMetadata;
var gatsbyConfigPlugins = gatsbyConfig.plugins;
var gatsbyConfigPluginsAP = gatsbyConfigPlugins.find(function (o) {
  return o.resolve === 'gatsby-plugin-accropress';
});
var gatsbyConfigPluginsAPOptions = gatsbyConfigPluginsAP && gatsbyConfigPluginsAP.resolve === 'gatsby-plugin-accropress' && gatsbyConfigPluginsAP.options ? gatsbyConfigPluginsAP.options : {};

require('es6-promise').polyfill();

export default function StandardPagePage(_ref) {
  var _ref$pageContext = _ref.pageContext,
      integratorData = _ref$pageContext.integratorData,
      contentMetaData = _ref$pageContext.contentMetaData,
      contentDataData = _ref$pageContext.contentDataData,
      navResultData = _ref$pageContext.navResultData,
      pluginOptions = _ref$pageContext.pluginOptions,
      props = _ref.props;
  var config = pluginOptions;
  console.log('contentDataData', contentDataData);

  var returnParentArray = function returnParentArray(id) {
    if (id) {
      if (navResultData && navResultData.menu && navResultData.menu.length > 0) {
        var parentArrayData = navResultData.menu.filter(function (item) {
          return item.id === id;
        });
        return parentArrayData[0];
      } else {
        return {};
      }
    } else {
      return {};
    }
  };

  var pageParentDataArray = {};

  if (contentMetaData && contentMetaData.parent && contentMetaData.parent.id) {
    pageParentDataArray = returnParentArray(contentMetaData.parent.id);
  }

  function dynamicSort(property) {
    var sortOrder = 1;

    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }

    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  return /*#__PURE__*/_jsxs(Layout, Object.assign({}, props, {
    navResultData: navResultData,
    contentDataData: contentDataData,
    integratorData: integratorData,
    contentMetaData: contentMetaData,
    pluginOptions: pluginOptions,
    children: [/*#__PURE__*/_jsx(SEO, {
      navResultData: navResultData,
      contentDataData: contentDataData,
      integratorData: integratorData,
      contentMetaData: contentMetaData,
      gatsbyConfigSiteMetaData: gatsbyConfigSiteMetaData,
      gatsbyConfigPluginsAPOptions: gatsbyConfigPluginsAPOptions
    }), contentDataData && contentDataData.length > 0 ? /*#__PURE__*/_jsxs("div", {
      className: "main-page-wrapper loaded",
      children: [/*#__PURE__*/_jsx("div", {
        className: "banner page",
        style: {
          backgroundImage: "linear-gradient(\n                to bottom,\n                rgba(0, 0, 0, 0.4),\n                rgba(0, 0, 0, 0.1)\n              ),\n              url(\"" + (contentDataData[0].children[2] && contentDataData[0].children[2].value ? returnResizedImageURL({
            w: 1900
          }, contentDataData[0].children[2].value) : returnResizedImageURL({
            w: 1900
          }, '/banner.jpg')) + "\")"
        },
        children: /*#__PURE__*/_jsx("div", {
          className: "container",
          children: /*#__PURE__*/_jsxs("div", {
            className: "bannerWrapper",
            children: [/*#__PURE__*/_jsx("h1", {
              children: contentMetaData.title
            }), /*#__PURE__*/_jsxs("div", {
              className: "breadcrumb",
              children: [/*#__PURE__*/_jsx(Link, {
                to: "/",
                children: "Home"
              }), " /", ' ', /*#__PURE__*/_jsx("span", {
                className: "active",
                children: contentMetaData.title
              })]
            })]
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "mainContentWrapper page",
        children: /*#__PURE__*/_jsx("section", {
          className: "app-content",
          children: /*#__PURE__*/_jsx("div", {
            className: "container",
            children: /*#__PURE__*/_jsxs("div", {
              className: "row",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "col-12 col-8-m pageMain",
                children: [contentMetaData.title !== contentDataData[0].children[0].value && /*#__PURE__*/_jsx("h2", {
                  children: contentDataData[0].children[0].value
                }), /*#__PURE__*/_jsx(WigLoader, {
                  accroPressSiteID: config.accroPressSiteID,
                  gatsbyConfigSiteMetaData: gatsbyConfigSiteMetaData,
                  gatsbyConfigPluginsAPOptions: gatsbyConfigPluginsAPOptions,
                  weducWebsitesID: config.weducWebsitesID,
                  weducContainer: config.weducContainerID,
                  weducEntity: config.weducEntityID,
                  contentDataData: contentDataData,
                  contentMetaData: contentMetaData,
                  contentDataArray: "0",
                  contentDataChild: "1",
                  AccroPressProdEndpoint: config.apiEndpoint,
                  AccroPressLocalEndpoint: config.apiEndpoint,
                  integratorID: config.integratorID,
                  integratorAccessToken: config.integratorAccessToken,
                  imageFormatting: process.env.IMAGE_FORMATTING_SECRET || process.env.GATSBY_IMAGE_FORMATTING_SECRET
                })]
              }), /*#__PURE__*/_jsx("div", {
                className: "col-12 col-4-m",
                children: contentMetaData ? /*#__PURE__*/_jsx("div", {
                  className: "pageSidebar",
                  children: /*#__PURE__*/_jsx(TableOfContents, {
                    contentMetaData: contentMetaData,
                    contentDataData: contentDataData,
                    integratorData: integratorData,
                    navResultData: navResultData
                  })
                }) : /*#__PURE__*/_jsx(_Fragment, {})
              })]
            })
          })
        })
      })]
    }) : /*#__PURE__*/_jsx("div", {
      className: "main-page-wrapper loading"
    })]
  }));
}